
// Initilise the Tender viewer page
var TECL_TenderViewer = {

    // Initialise the Tenders select page
    Initialise: function() {
        window.scrollTo(0, 0);

        TECL_TenderViewer.ToggleProductInfo(false);
    },

    // Open and close the product info section
    ToggleProductInfo: function(open) {
        if (open) {
            $("#productInformationContent").removeClass("hidden");
            $("#productDetailsOpen").addClass("hidden");
            $("#productDetailsClose").removeClass("hidden");
        } else {
            $("#productInformationContent").addClass("hidden");
            $("#productDetailsOpen").removeClass("hidden");
            $("#productDetailsClose").addClass("hidden");
        }
    },

    // Display the supplier notes dialog
    DisplaySupplierNotes: function(headerText, notes) {

        var $dlg = $("#SupplierNotesDialog");

        if ($dlg) {
            var $headerNode = $dlg.find("[name=dlgTitle]");
            var $bodyNode = $dlg.find("[name=dlgBody]");

            if ($bodyNode && $headerNode) {
                $headerNode.html(headerText);
                $bodyNode.html(notes);
                $dlg.modal("show");
            }
        }
    }

};